export default __webpack_public_path__ + "static/media/penbox.dbbdcc86.mp4";